import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import AttentionIcon from '@components/icons/Attention.svg';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import React from 'react';
import { useNavigate } from 'react-router';

type TProps = {
  onCancel: () => void;
};

export const UpgradeToAIFeatures = ({ onCancel }: TProps) => {
  const { closeModal } = useModalContext();
  const navigate = useNavigate();
  const { organization } = useAuthContext();

  const goToBilling = (evt: React.MouseEvent<HTMLButtonElement>) => {
    closeModal();
    evt.preventDefault();
    navigate(routes.billingAccount.make(organization?.slug ?? ''));
  };

  return (
    <ModalWrapper width="330px">
      <div className="mx-auto">
        <AttentionIcon />
      </div>
      <div className="text-center">
        If you want to use AI to improve the quality of your transcript, upgrade to Growth, Pro or Enterprise plans
      </div>
      <div className="flex justify-between">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button onClick={goToBilling} style={{ width: '130px' }}>
          Go to Upgrade
        </Button>
      </div>
    </ModalWrapper>
  );
};
